import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { useQuery } from "hooks/useParamsState";

export default function useQueryParamsState(key: string): [string | null, (newValue?: string) => void] {
	const navigate = useNavigate();

	const params = useQuery();
	const value = useMemo(() => params.get(key), [params, key]);

	const setValue = (newValue?: string) => {
		newValue ? params.set(key, newValue) : params.delete(key);
		navigate({ search: params.toString() });
	};

	return [value, setValue];
}
